<template>
  <div class="elePowerBox">
    <div class="powerTop">
      <div>{{ elePowerTitle }}</div>
      <div>
        <slot name="time"></slot>
      </div>
    </div>
    <div class="powerMain">
      <slot name="main"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    elePowerTitle: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="less">
.elePowerBox{
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
}

.powerTop{
  width: 100%;
  height: 20%;
  min-width: 0;
  min-height: 0;
  padding: 0 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #252B3C;
  font-size: 13px;
  font-weight: 600;
}

.powerMain{
  flex: 1;
  height: 80%;
  min-width: 0;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
</style>
